import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store';

const ShiftsLookupState = (state: RootState) => state.lookups.shifts;

export const selectShifts = (state: RootState) => ShiftsLookupState(state).rows;
export const shiftsLoading = (state: RootState) => ShiftsLookupState(state).loading;

export const selectShiftById = createSelector([selectShifts, (_: RootState, id?: string) => id], (rows, id) =>
  rows.find(({ id: rowId }) => id === rowId),
);

export const selectPricePlanShifts = createSelector(selectShifts, (rows) =>
  rows.map(({ id, name, allow_weekdays, allow_rostering }) => ({ id, name, allow_weekdays, allow_rostering })),
);

export const selectLookupShifts = createSelector(selectPricePlanShifts, (rows) =>
  rows.filter((x) => x.allow_rostering),
);
